import { EmeraldError } from './emerald-error';

/* 
  AbortedError is used for flow control
  At any time when you want to teminate a flow but do not want popupmessage you can use: throw new AbortedError();
*/
export class AbortedError extends EmeraldError {
  public constructor(code?: string, message?: string) {
    super();
    this.code = code ?? 'AbortedAction';
    this.message = message ?? 'Action aborted';
  }
}

export class ProhibitActionError extends EmeraldError {
  public constructor(
    code?: string,
    message?: string,
    showInfo: boolean = true,
    data?: any,
    voidTransactionOnDecline: boolean = false,
  ) {
    super();
    this.code = code ?? 'ProhibitAction';
    this.message = message ?? 'Action prohibited';
    this.showInfo = showInfo || voidTransactionOnDecline;
    this.data = data;
    this.voidTransactionOnDecline = voidTransactionOnDecline;
  }
  public showInfo?: boolean;
  public voidTransactionOnDecline?: boolean;
}
